import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { images } from '../data/megapack';
const guarantees = ['Acceso inmediato', 'Pago seguro', 'Garantía 7 días', 'Mercado Pago'];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-forest-800 px-5 pb-14 pt-12 text-center text-cream sm:pb-20 sm:pt-16" data-id="element-102" data-mp="9l375k8q6q7o">
      <div className="paper-dots-light absolute inset-0 opacity-70" aria-hidden="true" data-id="element-103" data-mp="129h5y27n1qka" />
      <div className="absolute left-1/2 top-0 h-72 w-[36rem] -translate-x-1/2 rounded-full bg-lime-500/15 blur-3xl" aria-hidden="true" data-id="element-104" data-mp="1274l9hahx23j" />

      <div className="hero-in relative mx-auto max-w-3xl" data-id="element-105" data-mp="sai16upzuf2k">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-lime-200" data-id="element-106" data-mp="sd48ct8z2sk9">
          Para maestras jardineras de Nivel Inicial
        </p>

        <h1 className="mx-auto mt-4 max-w-2xl font-display text-[32px] font-extrabold leading-[1.1] tracking-tight sm:text-5xl" data-id="element-107" data-mp="3d2bmnxfzddz8">
          Todo tu año de Nivel Inicial{' '}
          <span className="text-gold-400" data-id="element-108" data-mp="3j895n7fl21mw">organizado en un solo lugar.</span>
        </h1>

        <div className="relative mx-auto mt-9 max-w-xl" data-id="element-109" data-mp="3o85a17s6zv2z">
          <div className="absolute inset-6 rounded-full bg-lime-500/20 blur-3xl" aria-hidden="true" data-id="element-110" data-mp="3o5j3nbh1flmc" />
          <img src={images.hero} alt="MegaPack Seño Jardín: 6 tomos, 5 bonos y acceso digital para maestras de Nivel Inicial" width={1240} height={1240} sizes="(min-width: 640px) 576px, 100vw" loading="eager" fetchPriority="high" decoding="async" className="relative aspect-square w-full rounded-[1.5rem] border-4 border-cream/15 object-cover shadow-lift" data-id="element-111" data-mp="39cfkiznsszti" />
        </div>

        <p className="mx-auto mt-9 max-w-xl text-sm leading-relaxed text-cream/80 sm:text-base" data-id="element-112" data-mp="2ql6dqy5ewp5m">
          El sistema digital para maestras jardineras que quieren planificar, organizar y disfrutar más
          su sala.{' '}
          <span className="mark-lime-dark font-bold text-cream" data-id="element-113" data-mp="2hl9qn0yo7yco">
            6 tomos principales + 5 bonos gratis
          </span>{' '}
          con recursos prácticos para sala de 3, 4 y 5 años.
        </p>

        <p className="mt-5 font-hand text-2xl text-lime-200 sm:text-3xl" data-id="element-114" data-mp="s3usg13klgcq">
          Planificá. Enseñá. Resolvé. Desde hoy.
        </p>

        <div className="mt-8" data-id="element-115" data-mp="ibgn6yda9rlt">
          <CtaButton data-id="element-116" data-mp="icrn2n3lyf7n">Quiero mi MegaPack ahora</CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-cream/75" data-id="element-117" data-mp="ddwzl7up42h7">
          {guarantees.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-118" data-mp="1b04aezhler20">
              <CheckIcon className="h-3.5 w-3.5 text-lime-400" aria-hidden="true" data-id="element-119" data-mp="162ugb6j9dr7u" />
              {item}
            </li>)}
        </ul>
      </div>
    </header>;
}